import type { AnyObj } from '@/types';
import wechatH5 from './wechatH5';
import wechatMp from './wechatMp';

export const uniPayment = async (wechatPayment: AnyObj) => {
  let payResult = null;
  // #ifdef H5
  payResult = await wechatH5(wechatPayment);
  // #endif

  // #ifdef MP-WEIXIN
  payResult = await wechatMp(wechatPayment);
  // #endif

  return payResult;
};
